/**
 *	    __                             _ _
 *	   / /  _                     _   (_) |
 *	  / /_ | |_  ____ ____   ____| |_  _| |  _
 *	 / __ \|  _)/ _  )    \ / _  |  _)| | | / )
 *	( (__) ) |_( (/ /| | | ( ( | | |__| | |< (
 *	 \____/ \___)____)_|_|_|\_||_|\___)_|_| \_)
 *
 * jQuery SlideShow6tk v3.11
 * Copyright 2019 6tematik
 * Contributing Author: Quentin POUZET
 * Date : 01/10/19
 *
 * Installation :
 * ------------------
 *
 * <link rel="stylesheet" type="text/css" href="jquery.slideshow.6tematik.css">
 * <script type="text/javascript" src="jquery-1.11.1.min.js"></script>
 * <script type="text/javascript" src="jquery-ui.min.js"></script>
 * <script type="text/javascript" src="jquery.slideshow.6tematik.js"></script>
 *
 * <div class="slideshow">
 * 		<ul>
 * 			<li><img /></li>
 * 			<li><img /></li>
 * 			<li><img /></li>
 * 			<li><img /></li>
 * 		</ul>
 * </div>
 *
 */

;(function($){

		var defaults = {

			//paramètres basiques
			"pauseOnHover"		 : false,			// Pause au survol
			"animation"			 : "slide",			// Slide ou fade
			"direction"			 : "horizontal",	// Direction du slideshow horizontal ou vertical (uniquement avec animation slide)
			"easing"			 : "easeInQuart",	// easing... (necessite jquery ui)
			"slideshowSpeed"	 : 7000, 			// Vitesse du slideshow
			"animationSpeed"	 : 600, 			// Vitesse de l'animation
			"autoPlay"			 : true,			// Demarrage auto
			"swipe"				 : true,			// Swipe
			"checkViewPort" 	 : true, 			// Check si le slider est dans le viewport
			"autoHeight"		 : false,			//Calcule automatiquement la hauteur du slideshow en mode fade

			//pagination - navigation
			"pagination"		 : true,			// Pagination oui ou non
			"generatePagination" : true,			// Generation auto de la pagination
			"navigation"		 : true,			// Fléches oui ou non
			"generateNavigation" : true,			// Generation auto des flèches de navigation
			"prevText"			 : "Previous",  	// Texte flèche précédent
			"nextText"			 : "Next",			// Texte flèche suivant
			"keyboard"			 : true,			// Evenements clavier ou non ?

			//Selecteurs html
			"containerClass"	 : "slideContainer", //Conteneur du slideshow
			"paginationClass" 	 : "pagination", 	 // Classe de la pagination
			"paginationActive" 	 : "active",	  	 // Classe active de la pagination
			"navigationClass" 	 : "navigation", 	 // Classe des éléments de navigation
			"prevClass" 		 : "arrow--prev",	 // Classe flèche précédent
			"nextClass" 		 : "arrow--next",	 // Classe flèche suivant

			// Callback
			moveStart 	: function(){},
			moveEnd 	: function(){},
			play		: function(){},
			pause		: function(){},
			init		: function() {}

		}

		$.fn.slideShow6tk = function(options){

			if(this.length == 0) return this;

			// support mutltiple elements
			if(this.length > 1){
				this.each(function(){$(this).slideShow6tk(options)});
				return this;
			}

			// create a namespace to be used throughout the plugin
			var slider = {};

			// set a reference to our slider element
			var el = this;

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//				     	NUMERO ALEATOIRE 					 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			slider.randNumber = function(n)
			{
				if(!n){ n = 5; }

				var text = '';
				var possible = '0123456789';

				for(var i=0; i < n; i++)
				{
					text += possible.charAt(Math.floor(Math.random() * possible.length));
				}

				return text;
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						INITIALISATION 						 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var init = function(){

				//On fusionne nos parametres
				slider.parametres = $.extend({}, defaults, options);

				slider.actionPermitted = true;
				slider.nbImages = false;
				slider.tailleLi = false;
				slider.timer = false;

				//Génération nom unique
				slider.name = "6tk"+slider.randNumber();

				//Check parametres
				if(slider.parametres.animationSpeed >= slider.parametres.slideshowSpeed){
					console.error("Attention, la vitesse de l'animation doit être inférieure à la vitesse du slideShow. Les paramètres ont été réinitialisés");
					//On recalcule
					slider.parametres.animationSpeed = (slider.parametres.slideshowSpeed / 2);
				}

				//On prépare le slideshow
				prepare();

				//Génération pagination
				generatePagination();

				//Génération navigation
				generateNavigation();

				//Swipe
				el.on("touchstart",touchstart);
				el.on("touchend",touchend);

				//Check viewport
				if(slider.parametres.checkViewPort){
					if( !!('ontouchstart' in window) ){
						// Touchscreen
						$("body").bind("touchmove MSPointerMove pointermove", checkViewPort);
					}
					else{
						// No touchscreen
						$(window).bind("scroll", checkViewPort);
					}
				}

				//Pause on hover
				if(slider.parametres.pauseOnHover){
					hoverPause();
				}

				//Resize
				$(window).bind('resize', resize);

				//keydown
				if(slider.parametres.keyboard){
					$(window).bind('keyup', keyboard);
				}

				//On indique que l'initialisation est faite
				slider.estInitialise = true;

				//Callback
				  slider.parametres.init(slider);

				//On lance le slideshow
				  play();

			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//					PREPARATION DU SLIDESHOW 				 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var prepare = function(){

				//Si le conteneur n'est pas défini
				if(!slider.parametres.container){
					slider.parametres.containerClass = "slideContainer";
				}

				//On crée un conteneur autour du slideshow qui va accueillir les différents élements
				el.wrap( "<div class='"+slider.parametres.containerClass+"'></div>" );

				//On ajoute la classe active au premier élément
				el.children("ul").children("li").eq(0).addClass("active-slide");

				//Calcul du nombre d'image
				slider.nbImages = el.children("ul").children("li").length;

				//Calcul de la taille d'un li
				slider.tailleLi = el.outerWidth();

				//Hauteur d'un li
				slider.hauteurLi = el.height();

				//On set la taille des li
				el.children("ul").children("li").css("width",slider.tailleLi);

				//On clone la première et la dernière image
				el.children("ul").children("li").eq(0).clone().appendTo(el.children("ul")).addClass("clone");
				el.children("ul").children("li").eq(slider.nbImages-1).clone().prependTo(el.children("ul")).addClass("clone");

				//Initialisation du slideShow
				if(slider.parametres.animation == "slide"){

					//-------------------------> SLIDE <-------------------------

					if(slider.parametres.direction == "vertical"){

						//Calcul de la taille du conteneur
						var totalHeight = 0;
						el.children("ul").children("li").each(function() {
							totalHeight = totalHeight + $(this).outerHeight();
						});


						//On applique le css aux différents éléments
						el.children("ul").css("height",totalHeight+"px");

						//On se positionne sur la seconde image
						el.children("ul").css("margin-top",'-'+slider.hauteurLi+'px');


					}else{
						//Calcul de la taille du conteneur
						var totalWidth = 0;
						el.children("ul").children("li").each(function() {
							totalWidth = totalWidth + $(this).outerWidth();
						});

						//On applique le css aux différents éléments
						el.children("ul").css("width",totalWidth+"px");
						el.children("ul").children("li").css("float","left");

						//On se positionne sur la seconde image
						el.children("ul").css("margin-left",'-'+slider.tailleLi+'px');
					}



				}else{

					//-------------------------> FADE <-------------------------

					if(slider.parametres.autoHeight){
						//On calcule la hauteur du slide le plus grand élément
						var hauteurMax = 0;
						el.children("ul").children("li").each(function(){
							var hauteurSlide = $(this).outerHeight();
							if(hauteurSlide > hauteurMax){
								hauteurMax = hauteurSlide;
							}
						});

						//On applique la hauteur au conteneur
						el.css("height",hauteurMax);
						el.children("ul").css("height",hauteurMax);
					}

					//On passe tous les slides en absolute
					el.children("ul").css("position","relative");
					el.children("ul").children("li").css({"position":"absolute", "top":0, "left":0});

					//On cache tous les slides sauf le second (la premiere image apres le clone)
					el.children("ul").children("li").css("display","none");
					el.children("ul").children("li").eq(1).css("display","block");
				}
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//							AUTOPLAY 						 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var play = function(){
				//On play uniquement si il y a plus d'un bandeau
				if(el.children("ul").children("li").not(".clone").length > 1){
					if(slider.parametres.autoPlay && slider.timer == false){
						slider.timer = setInterval(function(){

							//On avance
							if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
								moveBottom();
							}else{
								moveRight();
							}

							//
						   },slider.parametres.slideshowSpeed);

						   //Callback
						slider.parametres.play(slider);
					}
				}
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						      PAUSE 	 					 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			var pause = function(){
				if(slider.timer){
					clearInterval(slider.timer);
					slider.timer = false;
				}

				//Callback
				slider.parametres.pause(slider);
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//				AUTORISE LES ACTIONS OU NON 				 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			var actionSwitchTo = function(authorization){
				if(!authorization){
					slider.actionPermitted = false; // On interdit
				}else{
					slider.actionPermitted = true; // On autorise
				}
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						MOVE LEFT (Previous)				 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var moveLeft = function(speed){

				//Callback
				slider.parametres.moveStart(slider);

				//Création d'un objet différé
				var deferred = $.Deferred();

				//Quelle est la position en cours
				var positionActif = el.children("ul").children("li").index(el.find(".active-slide"));

				//Vitesse d'animation
				if(!speed){
					speed = slider.parametres.animationSpeed;
				}

				if(slider.parametres.animation == "slide"){
					//-------------------------> SLIDE <-------------------------

					//On bouge en arriere
					el.children("ul").stop(true,true).animate({marginLeft:'+='+slider.tailleLi},speed,slider.parametres.easing,function(){

						//On décrémente la position active
						positionActif--;


						if((positionActif) == 0){
							   //Calcul de la position max
							   var positionMax = slider.tailleLi * slider.nbImages;

							   //Si on est au début, go à la fin
							   el.children("ul").css("margin-left","-"+positionMax+'px');

							   //On met à jour le slide actif
							   el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(slider.nbImages).addClass("active-slide");

							   //On prépare la nouvelle pagination
							   var pagination = slider.nbImages-1;

						   }else{
							   //On met à jour le slide actif
							   el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(positionActif).addClass("active-slide");

							   //On prépare la nouvelle pagination
							   var pagination = positionActif-1;
						   }

						   //On met à jour la pagination
						   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
						   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").eq(pagination).addClass(slider.parametres.paginationActive);

						   //Callback
							slider.parametres.moveEnd(slider,pagination + 1);

						   //On indique que tout s'est bien passé
						   deferred.resolve();
					});
				}else{
					//-------------------------> FADE <-------------------------

					//On affiche le slide suivant et on passe le slide en cours par dessus
					if((positionActif-1) == 0){
						   el.children("ul").children("li").eq(slider.nbImages).css("z-index",1);
						el.children("ul").children("li").eq(slider.nbImages).css({"display":"block"});
					}else{
						el.children("ul").children("li").eq(positionActif-1).css("z-index",1);
						el.children("ul").children("li").eq(positionActif-1).css({"display":"block"});
					}

					el.children("ul").children("li").eq(positionActif).css("z-index",10);

					//On cache le slide en cours pour faire apparaitre le suivant
					el.children("ul").children("li").eq(positionActif).stop(true,true).fadeOut(speed, slider.parametres.easing, function(){

						//On décrémente la position active
						positionActif--;

						//reset z-index
						el.children("ul").children("li").css("z-index","");

						if((positionActif) == 0){

							   //On met à jour le slide actif
							   el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(slider.nbImages).addClass("active-slide");
							   el.children("ul").children("li").not(':eq('+(slider.nbImages)+')').css("display","none");

							   //On prépare la nouvelle pagination
							   var pagination = slider.nbImages-1;

						   }else{
							   //On met à jour le slide actif
							   el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(positionActif).addClass("active-slide");
							   el.children("ul").children("li").not(':eq('+(positionActif)+')').css("display","none");

							   //On prépare la nouvelle pagination
							   var pagination = positionActif-1;

						   }

						   //On met à jour la pagination
						   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
						   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").eq(pagination).addClass(slider.parametres.paginationActive);

						   //Callback
							slider.parametres.moveEnd(slider,pagination + 1);

						   //On indique que tout s'est bien passé
						   deferred.resolve();

					});
				}

				//
				return deferred.promise();
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						MOVE RIGHT (Next) 					 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var moveRight = function(speed){

				//Callback
				slider.parametres.moveStart(slider);

				//Création d'un objet différé
				var deferred = $.Deferred();

				//Quelle est la position en cours
				var positionActif = el.children("ul").children("li").index(el.find(".active-slide"));

				//Vitesse d'animation
				if(!speed){
					speed = slider.parametres.animationSpeed;
				}

				if(slider.parametres.animation == "slide"){

					//-------------------------> SLIDE <-------------------------

					//On bouge en avant
					el.children("ul").stop(true,true).animate({marginLeft:'-='+slider.tailleLi},speed,slider.parametres.easing,function(){

						//Gestion pagination et clones
						if((positionActif) == slider.nbImages){

							//Si on est à la fin, retour au premier slide (le 2eme apres le clone)
							el.children("ul").css("margin-left",-slider.tailleLi);

							//On met à jour le slide actif
							   el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(1).addClass("active-slide");

							//On prépare la nouvelle pagination
							var pagination = 0;

						}else{

							//On met à jour le slide actif
							   el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(positionActif+1).addClass("active-slide");

							//On prépare la nouvelle pagination
							var pagination = positionActif;

						}

						//On met à jour la pagination
						$("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
						$("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").eq(pagination).addClass(slider.parametres.paginationActive);

						//Callback
						slider.parametres.moveEnd(slider,pagination + 1);

						//On indique que tout s'est bien passé
						deferred.resolve();
					});
				}else{

					//-------------------------> FADE <-------------------------

					//On affiche le slide suivant et on passe le slide en cours par dessus
					if((positionActif) == slider.nbImages){
						//Si on est arrivé à la fin on affiche le 1er
						el.children("ul").children("li").eq(1).css("z-index",1);
						   el.children("ul").children("li").eq(1).css({"display":"block"});
					}else{
						el.children("ul").children("li").eq(positionActif+1).css("z-index",1);
						   el.children("ul").children("li").eq(positionActif+1).css({"display":"block"});
					}

					//On passe le slide courant par dessus
					el.children("ul").children("li").eq(positionActif).css("z-index",10);

					//On cache le slide en cours pour faire apparaitre le suivant
					el.children("ul").children("li").eq(positionActif).stop(true,true).fadeOut(speed, slider.parametres.easing, function(){
						//reset z-index
						el.children("ul").children("li").css("z-index","");

						//Reset display
						if((positionActif) == slider.nbImages){
							el.children("ul").children("li").not(':eq(1)').css("display","none");
							el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(1).addClass("active-slide");
							   //On prépare la nouvelle pagination
							var pagination = 0;

						}else{
							el.children("ul").children("li").not(':eq('+(positionActif+1)+')').css("display","none");
							el.children("ul").children("li.active-slide").removeClass("active-slide");
							   el.children("ul").children("li").eq(positionActif+1).addClass("active-slide");
							//On prépare la nouvelle pagination
							var pagination = positionActif;
						}

						//On met à jour la pagination
						   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
						$("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").eq(pagination).addClass(slider.parametres.paginationActive);

						//Callback
						slider.parametres.moveEnd(slider,pagination + 1);

						//On indique que tout s'est bien passé
						  deferred.resolve();
					});
				}

				//
				return deferred.promise();

			}


			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						MOVE TOP (PREVIOUS)			 		 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var moveTop = function(speed){

				//Callback
				slider.parametres.moveStart(slider);

				//Création d'un objet différé
				var deferred = $.Deferred();

				//Quelle est la position en cours
				var positionActif = el.children("ul").children("li").index(el.find(".active-slide"));

				//Vitesse d'animation
				if(!speed){
					speed = slider.parametres.animationSpeed;
				}

				//On bouge en arriere
				el.children("ul").stop(true,true).animate({marginTop:'+='+slider.hauteurLi},speed,slider.parametres.easing,function(){

					//On décrémente la position active
					positionActif--;

					if((positionActif) == 0){
						   //Calcul de la position max
						   var positionMax = slider.hauteurLi * slider.nbImages;

						   //Si on est au début, go à la fin
						   el.children("ul").css("margin-top","-"+positionMax+'px');

						   //On met à jour le slide actif
						   el.children("ul").children("li.active-slide").removeClass("active-slide");
						   el.children("ul").children("li").eq(slider.nbImages).addClass("active-slide");

						   //On prépare la nouvelle pagination
						   var pagination = slider.nbImages-1;

					   }else{
						   //On met à jour le slide actif
						   el.children("ul").children("li.active-slide").removeClass("active-slide");
						   el.children("ul").children("li").eq(positionActif).addClass("active-slide");

						   //On prépare la nouvelle pagination
						   var pagination = positionActif-1;
					   }

					   //On met à jour la pagination
					   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
					   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").eq(pagination).addClass(slider.parametres.paginationActive);

					   	//Callback
						slider.parametres.moveEnd(slider,pagination + 1);

					   	//On indique que tout s'est bien passé
					  	deferred.resolve();
				});

				//
				return deferred.promise();
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						MOVE BOTTOM (NEXT)				 	 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var moveBottom = function(speed){

				//Callback
				slider.parametres.moveStart(slider);

				//Création d'un objet différé
				var deferred = $.Deferred();

				//Quelle est la position en cours
				var positionActif = el.children("ul").children("li").index(el.find(".active-slide"));

				//Vitesse d'animation
				if(!speed){
					speed = slider.parametres.animationSpeed;
				}

				//On bouge
				el.children("ul").stop(true,true).animate({marginTop:'-='+slider.hauteurLi},speed,slider.parametres.easing,function(){

					//Gestion pagination et clones
					if((positionActif) == slider.nbImages){

						//Si on est à la fin, retour au premier slide (le 2eme apres le clone)
						el.children("ul").css("margin-top",-slider.hauteurLi);

						//On met à jour le slide actif
						   el.children("ul").children("li.active-slide").removeClass("active-slide");
						   el.children("ul").children("li").eq(1).addClass("active-slide");

						//On prépare la nouvelle pagination
						var pagination = 0;

					}else{

						//On met à jour le slide actif
						   el.children("ul").children("li.active-slide").removeClass("active-slide");
						   el.children("ul").children("li").eq(positionActif+1).addClass("active-slide");

						//On prépare la nouvelle pagination
						var pagination = positionActif;

					}

					//On met à jour la pagination
					   $("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
					$("body").find("."+slider.name+"."+slider.parametres.paginationClass).children("li").eq(pagination).addClass(slider.parametres.paginationActive);

					//Callback
					slider.parametres.moveEnd(slider,pagination + 1);

					//On indique que tout s'est bien passé
					deferred.resolve();


				});

				//
				return deferred.promise();
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						PAGINATION 					 		 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var generatePagination = function(){

				//Si on a plus d'un slide et qu'on souhaite faire apparaitre la  pagination
				if(slider.parametres.pagination && el.children("ul").children("li").not(".clone").length > 1){

					//Si il faut générer la pagination
					if(slider.parametres.generatePagination){

						//Conteneur pagination
						el.parent().append("<ul class='"+slider.name+" "+slider.parametres.paginationClass+"'></ul>");

						//Création des pages
						for (var i = 0; i < slider.nbImages; i++) {
							if(i == 0){
								el.parent().find("."+slider.parametres.paginationClass).append("<li class='"+slider.parametres.paginationActive+"'><a href='#'>"+(i+1)+"</a></li>");
							}else{
								el.parent().find("."+slider.parametres.paginationClass).append("<li><a href='#'>"+(i+1)+"</a></li>");
							}
						};
					}else{
						$("."+slider.parametres.paginationClass).addClass(slider.name);
					}

					//On bind le click sur la pagination
					$("body").on("click", "."+slider.name+"."+slider.parametres.paginationClass+" > li > a",clickPagination);
				}
			}

			var clickPagination = function(){

				//Callback
				slider.parametres.moveStart(slider);

				//On stop le timer
				pause();

				//Si les actions sont permises
				if(slider.actionPermitted){

					//On empèche tout autre action
					actionSwitchTo(false);

					//On regarde sur quelle page on a cliqué
					var pageCliquee = $(this).parent("li").index();

					

					//On met à jour la pagination

					//
					// ATTENTION, POTENTIELLEMENT BUGGE
					//

					//el.parent().find("."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
					//el.parent().find("."+slider.parametres.paginationClass).children("li").eq(pageCliquee).addClass(slider.parametres.paginationActive);

					$("."+slider.name+"."+slider.parametres.paginationClass).children("li").removeClass(slider.parametres.paginationActive);
					$("."+slider.name+"."+slider.parametres.paginationClass).children("li").eq(pageCliquee).addClass(slider.parametres.paginationActive);

					if(slider.parametres.animation == "slide"){

						//Calcul position future
						if(slider.parametres.direction == "vertical"){

							var position = (parseInt(slider.hauteurLi) * pageCliquee) + slider.hauteurLi;

							//On va sur la bonne image
							el.children("ul").stop(true,true).animate({marginTop:'-'+position+'px'},slider.parametres.animationSpeed,slider.parametres.easing,function(){
								//On autorise  à nouveau les actions
							actionSwitchTo(true);
							});
						}else{

							var position = (parseInt(slider.tailleLi) * pageCliquee) + slider.tailleLi;

							//On va sur la bonne image
							el.children("ul").stop(true,true).animate({marginLeft:'-'+position+'px'},slider.parametres.animationSpeed,slider.parametres.easing,function(){
							
							//On autorise  à nouveau les actions
							actionSwitchTo(true);
							});
						}



					}else{

						//On récupère l'image actuellement visible
						var indexSlide = el.children("ul").children("li").index(el.find(".active-slide"));

						if(indexSlide != (pageCliquee+1)){

							//On affiche le slide voulu et on passe le slide en cours par dessus
							el.children("ul").children("li").eq(pageCliquee+1).css("z-index",1);
							el.children("ul").children("li").eq(pageCliquee+1).css({"display":"block"});

							el.children("ul").children("li").eq(indexSlide).css("z-index",10);

							//On cache le slide en cours pour faire apparaitre le suivant
							el.children("ul").children("li").eq(indexSlide).stop(true,true).fadeOut(slider.parametres.animationSpeed, slider.parametres.easing, function(){
								//reset z-index
								el.children("ul").children("li").css("z-index","");

								//Reset display
								el.children("ul").children("li").not(':eq('+(pageCliquee+1)+')').css("display","none");

								//On autorise  à nouveau les actions
								actionSwitchTo(true);
							});
						}else{
							// On vient de cliquer sur le slide actif, pas d'animation, on peut autoriser à nouveau les actions
							actionSwitchTo(true);
						}

						
					}

					//Callback
					slider.parametres.moveEnd(slider,pageCliquee+1);

					//On met à jour le slide actif
					el.children("ul").children("li").removeClass("active-slide");
					el.children("ul").children("li").eq(pageCliquee+1).addClass("active-slide");

				}

				//On relance le timer
				if(!slider.enpause){
					play();
				}

				return false;
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						   NAVIGATION 						 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var generateNavigation = function(){

				//Si on a plus d'un slide et qu'on souhaite faire apparaitre la navigation
				if(slider.parametres.navigation && el.children("ul").children("li").not(".clone").length > 1){

					//Si il faut générer la navigation
					if(slider.parametres.generateNavigation){
						//Conteneur navigation
						el.parent().append("<ul class='"+slider.name+" "+slider.parametres.navigationClass+"'></ul>");

						//Ajout des flèches
						el.parent().find("."+slider.parametres.navigationClass).append("<li class='"+slider.name+" "+slider.parametres.prevClass+"'><a href='#'>"+slider.parametres.prevText+"</a></li>");
						el.parent().find("."+slider.parametres.navigationClass).append("<li class='"+slider.name+" "+slider.parametres.nextClass+"'><a href='#'>"+slider.parametres.nextText+"</a></li>");
					}else{
						$("."+slider.parametres.prevClass).addClass(slider.name);
						$("."+slider.parametres.nextClass).addClass(slider.name);
					}

					//On bind le click sur les liens
					$("body").on("click", "."+slider.name+"."+slider.parametres.prevClass,precedent);
					$("body").on("click", "."+slider.name+"."+slider.parametres.nextClass,suivant);

				}

			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//					CLICK FLECHE PRECEDENT 					 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var precedent = function(){

				//Si les actions sont permises
				if(slider.actionPermitted){

					//On stop le timer
					pause();

					//On empèche tout autre action
					actionSwitchTo(false);

					//On lance moveleft ou moveTop et on attend que l'action soit terminée
					if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
						var promise = moveTop();
					}else{
						var promise = moveLeft();
					}

					promise.done(function() {

						//On relance le timer
						if(!slider.enpause){
							play();
						}

						//On autorise  à nouveau les actions
						actionSwitchTo(true);
					});
				}

				return false;
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//					CLICK FLECHE SUIVANT 					 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var suivant = function(){

				//Si les actions sont permises
				if(slider.actionPermitted){

					//On stop le timer
					pause();

					//On empèche tout autre action
					actionSwitchTo(false);

					//On lance moveRight ou moveBottom et on attend que l'action soit terminée
					if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
						var promise = moveBottom();
					}else{
						var promise = moveRight();
					}

					promise.done(function() {

						//On relance le timer
						if(!slider.enpause){
							play();
						}

						//On autorise  à nouveau les actions
						actionSwitchTo(true);
					});

				}

				return false;

			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//			VERIF SI LE SLIDER EST DANS LE VIEWPORT  		 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			slider.allowCheckViewPort = true;

			var checkViewPort = function(){
				//Si la vérification du viewport est autorisée
				if(slider.allowCheckViewPort){
					var win = $(window);

					var viewport = {
						top : win.scrollTop(),
						left : win.scrollLeft()
					};
					viewport.right = viewport.left + win.width();
					viewport.bottom = viewport.top + win.height();
					//
					var bounds = el.parent("."+slider.parametres.containerClass).offset();
					bounds.right = bounds.left + el.parent("."+slider.parametres.containerClass).outerWidth();
					bounds.bottom = bounds.top + el.parent("."+slider.parametres.containerClass).outerHeight();

					if (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom)){
						if(slider.enpause){
							play();
							slider.enpause = false;
						}
					}else{
						if(slider.timer){
							pause();
							slider.enpause = true;
						}

					}
				}
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						  KEYBOARD 			   		 		 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var keyboard = function(event){

				if(slider.actionPermitted){

					switch (event.keyCode) {
						case 37: // flèche gauche - flèche haut
						case 38:

							//On stop le timer
							pause();

							//On empèche tout autre action
							actionSwitchTo(false);

							//On lance moveleft et on attend que l'action soit terminée
							if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
								var promise = moveTop();
							}else{
								var promise = moveLeft();
							}

							promise.done(function() {

								//On relance le timer
								if(!slider.enpause){
									play();
								}

								//On autorise  à nouveau les actions
								actionSwitchTo(true);
							});


						break;

						case 39: // flèche droite - flèche bas
						case 40:

							//On stop le timer
							pause();

							//On empèche tout autre action
							actionSwitchTo(false);

							//On lance moveleft et on attend que l'action soit terminée
							if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
								var promise = moveBottom();
							}else{
								var promise = moveRight();
							}

							promise.done(function() {

								//On relance le timer
								if(!slider.enpause){
									play();
								}

								//On autorise  à nouveau les actions
								actionSwitchTo(true);
							});

						break;
					}

					return false;

				}
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						  SWIPE 			   		 		 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			slider.swipestart = 0;
			slider.swipestartTime =0;

			var touchstart = function(event){
				//event.preventDefault();
				if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
					slider.swipestart = event.originalEvent.touches[0].clientY;
				}else{
					slider.swipestart = event.originalEvent.touches[0].clientX;
				}
				slider.swipestartTime = new Date().getTime()
			}

			var touchend = function(event){

				if(slider.actionPermitted && slider.parametres.swipe){

					//Calcul des distances
					if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
						var end = event.originalEvent.changedTouches[0].clientY;
					}else{
						var end = event.originalEvent.changedTouches[0].clientX;
					}
					var distance = slider.swipestart - end;

					//Calcul speed
					var endTime = new Date().getTime();
					var speed = endTime-slider.swipestartTime;

					if(distance < 0){
						//PREV
						if(-distance > 100){

							//On stop le timer
							pause();

							//On empèche tout autre action
							actionSwitchTo(false);

							//On lance moveleft et on attend que l'action soit terminée
							if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
								var promise = moveTop();
							}else{
								var promise = moveLeft();
							}

							promise.done(function() {

								//On relance le timer
								if(!slider.enpause){
									play();
								}

								//On autorise  à nouveau les actions
								actionSwitchTo(true);
							});
						}
					}else{
						// NEXT
						if(distance > 100){

							//On stop le timer
							pause();

							//On empèche tout autre action
							actionSwitchTo(false);

							//On lance moveleft et on attend que l'action soit terminée
							if(slider.parametres.direction == "vertical" && slider.parametres.animation == "slide"){
								var promise = moveBottom();
							}else{
								var promise = moveRight();
							}

							promise.done(function() {

								//On relance le timer
								play();

								//On autorise  à nouveau les actions
								actionSwitchTo(true);
							});
						}
					}
				}
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//							HOVERPAUSE 						 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var hoverPause = function(){
				el.hover(function(){
					if(slider.timer){
						pause();
						//
						slider.enpause = true;
					}
				},function(){
					if(slider.enpause){
						play();
						//
						slider.enpause = false;
					}
				});
			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//						RESIZE / RESPONSIVE 				 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			var resize = function(){

				//On stop le timer
				if(slider.timer){
					pause();
					slider.enpause = true;
				}

				var positionActif = el.children("ul").children("li").index(el.find(".active-slide"));

				//Calcul de la taille d'un li
				slider.tailleLi = el.outerWidth();
				slider.hauteurLi = el.height();
				//

				//On set la taille des li
				el.children("ul").children("li").css("width",slider.tailleLi);

				if(slider.parametres.animation == "slide"){

					//-------------------------> SLIDE <-------------------------

					if(slider.parametres.direction == "vertical"){

						//Calcul de la taille du conteneur
						var totalHeight = 0;
						el.children("ul").children("li").each(function() {
							totalHeight = totalHeight + $(this).outerHeight();
						});

						//On repositionne le slide en cours
						var position = (positionActif * slider.hauteurLi);

						//On applique le css aux différents éléments
						el.children("ul").css("height",totalHeight+"px");

						//On se positionne sur la seconde image
						el.children("ul").css("margin-top",'-'+position+'px');


					}else{

						 //On recalcule la taille de conteneur
						 var totalWidth = 0;
						 el.children("ul").children("li").each(function() {
							 totalWidth = totalWidth + $(this).outerWidth();
						});

						//On repositionne le slide en cours
						var position = (positionActif * slider.tailleLi);

						//On applique le css
						el.children("ul").css({
							"width":totalWidth+"px",
							"margin-left":"-"+position+"px"
						});
					}

				}else{

					//-------------------------> FADE <-------------------------

					if(slider.parametres.autoHeight){
						//On calcule la hauteur du slide le plus grand élément
						var hauteurMax = 0;
						el.children("ul").children("li").each(function(){
							var hauteurSlide = $(this).innerHeight();
							if(hauteurSlide > hauteurMax){
								hauteurMax = hauteurSlide;
							}
						});

						//On applique la hauteur au conteneur
						el.css("height",hauteurMax);
						el.children("ul").css("height",hauteurMax);
					}
				}

				//On relance le timer
				if(slider.enpause){
					   play();
				   }

			}

			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\
			//							DESTROY 						 //
			//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			el.destroy = function(){

				if(slider.estInitialise){

					//On arrête le slideshow
					pause();

					//On unbind tout
					el.off("touchstart",touchstart);
					el.off("touchend",touchend);
					//
					$("body").off("click", "."+slider.name+"."+slider.parametres.paginationClass+" > li > a",clickPagination);
					$("body").off("click","."+slider.name+"."+slider.parametres.prevClass,precedent);
					$("body").off("click","."+slider.name+"."+slider.parametres.nextClass,suivant);
					//
					$(window).unbind('resize', resize);
					$(window).unbind('keyup', keyboard);
					$("body").unbind("touchmove MSPointerMove pointermove", checkViewPort);
					$(window).unbind("scroll", checkViewPort);

					//On interdit slider.parametres.checkViewPort
					allowCheckViewPort = false;

					//On supprime les clones
					el.children("ul").children("li.clone").remove();

					//On enleve les classes actives
					el.children("ul").children("li.active-slide").removeClass("active-slide");

					//On supprime la navigation générée
					if(slider.parametres.generateNavigation){
						el.parent().children("."+slider.name+"."+slider.parametres.navigationClass).remove();
					}

					//On supprime la pagination générée
					if(slider.parametres.generatePagination){
						el.parent().children("."+slider.name+"."+slider.parametres.paginationClass).remove();
					}

					//On vire le css
					el.css("height","");
					el.children("ul").css({
						"width":"",
						"margin-left":"",
						"height":"",
						"position":""
					});

					el.children("ul").children("li").css({
						"float":"",
						"width":"",
						"top":"",
						"left":"",
						"position":"",
						"display":"",
						"z-index":""
					});

					//On indique que le slider n'est plus initialise
					slider.estInitialise = false;

					//Pour terminer, on supprime le conteneur
					el.unwrap();
				}
			}

			el.reload = function(parametres){

				if(parametres != undefined){
					options = parametres;
				}

				el.destroy();
				init();
			}

			el.play = function(){
				play();
			}

			el.pause = function(){
				pause();
			}

			//Initialisation du slideshow
			init();

			// returns the current jQuery object
			return this;
		}


	})(jQuery);